/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/VideoRecorder/_components/ThumbnailOverlay.js
 * Created:       Tue May 27 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React, { useState, useEffect, useContext } from "react";

import {TranslationsContext} from "@proxy/_contexts";

export default function ThumbnailOverlay({
  media,
  videoDuration,
  customThumbnail,
  updateFormField,
  formData,
  tainted,
  setTainted,
  setHasThumbnail
}) {
  const translations = useContext(TranslationsContext);

  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState(null);
  const [thumbnailImages, setThumbnailImages] = useState([]);

  const tempArray = [];

  const generateThumbnail = (min, max) => {
    return new Promise((resolve, reject) => {
      const canvas = document.getElementById(`gc__thumbnail_canvas`);
      const randomFrame = Math.round((Math.random() * (max - min) + min) * 1000) + 1;
      media.currentTime = randomFrame / 1000;

      setTimeout(() => {
        canvas.getContext('2d').drawImage( media, 0, 0, media.videoWidth/3, media.videoHeight/3 );
        try {
          tempArray.push(canvas.toDataURL());
        } catch (error) {
          setTainted(true);
          setLoading(false);
        }
        resolve();
      }, 750);
    });
  };

  const generateThumbnails = () => {
    generateThumbnail(0, videoDuration / 4)
    .then(function() {
      if ( !tainted ) {
        generateThumbnail(videoDuration / 4, (videoDuration / 4) * 3)
        .then(function() {
          generateThumbnail((videoDuration / 4) * 3, videoDuration)
          .then(function(){
            setThumbnailImages(tempArray);
            setLoading(false);
          })
          .catch(function(err) {
            console.log(err);
          });
        });
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    generateThumbnails();
  }, []);

  useEffect(() => {
    if (customThumbnail != "") {
      setLoading(true);
      updateFormField("properties._gcp_thumbnail_image", customThumbnail);
      if (thumbnailImages.length == 3) {
        setThumbnailImages([thumbnailImages[0], thumbnailImages[1], customThumbnail]);
      } else {
        setThumbnailImages([thumbnailImages[0], customThumbnail]);
      }
      setLoading(false);
    }
  }, [customThumbnail]);

  useEffect(() => {
    const buttons = thumbnailImages.map((image, index) => (
      <div key={`t_image_${index}`} className={"gc__thumbnail_radio_button"}>
        <input
          name="video_thumbnail"
          className={"gc__thumbnail_input"}
          type="radio"
          id={`t_image_${index}`}
          value={image}
          onChange={(e) => {
            updateFormField("properties._gcp_thumbnail_image", e.target.value);
            setHasThumbnail(true);
          }}
          checked={image === formData.properties._gcp_thumbnail_image}
        />
        <label className={"gc__thumbnail_radio_label"} htmlFor={`t_image_${index}`}>
          <img className={"gc__thumbnail_radio_image"} src={image} alt="" />
        </label>
      </div>
    ));
    setImages(buttons);
    // setLoading(false);
  }, [thumbnailImages, formData]);

  const thumbnailMarkup = ( loading ) ?
    <>{translations.video_recorder_loading_thumbnails}</> :
    <>{images}</>;

  return (
    <div className={"gc__thumbnail_images_wrapper"}>
      { thumbnailMarkup }
      <div className={"gc__hidden_canvas"}>
        <canvas id={"gc__thumbnail_canvas"} className={"gc__thumbnail_radio_image"}>
        </canvas>
      </div>
    </div>
  )
}
